export const style = {
    main: {
        minHeight: '100vh',
        backgroundColor: 'white',
        display: 'flex',
        flexDirection: 'column'
    },
    content: {
        justifyContent: 'center',
        flex: 1,
        px: '25px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },
    logoLabel: {
        ml: 2,
        color: 'primary.800',
        fontSize: '18px',
        fontWeight: 'bold'
    },
    title: {
        pt: '94px',
        mb: 2,
        fontWeight: 'bold',
        fontSize: '20px',
        lineHeight: '30px',
        textAlign: 'center',
        color: 'neutral.1000'
    },
    message: {
        display: 'flex',
        flexDirection: 'column'
    },
    description: {
        mb: 5,
        fontSize: 2,
        lineHeight: '21px',
        color: 'neutral.800',
        textAlign: 'center'
    },
    legalLinksDivider: {
        width: '100%',
        border: '1px solid #D4D2D0'
    },
    legalLinks: {
        px: 4
    },
    legalDisclaimer: {
        color: 'foreground',
        fontSize: 1,
        lineHeight: 'normal',
        margin: '1.25rem 0'
    }
};
